/**
 * The AppContainer instance is a module-level singleton (see
 * src/components/AppContainer/index.js) so that its state survives re-renders
 * of the unstated <Provider> — in particular the re-renders that Gatsby 5
 * triggers when hovering an internal <Link> (hover now performs a full page
 * load in the loader and re-renders the page tree).
 *
 * The flip side: the singleton also survives SPA navigations, while in the
 * original (Gatsby 2) setup a fresh page mounted a fresh <Provider> and the
 * menu/modal state was implicitly reset on every navigation. Close the
 * navigation menu and the form modals explicitly on route updates to keep
 * that original behaviour.
 *
 * NOTE: this file must stay pure CommonJS (Gatsby rejects mixed ESM/CJS
 * plugin files). The deferred require is only evaluated in the browser, where
 * webpack bundles it to the same AppContainer module (same singleton).
 */

let _appContainer = null

const getAppContainer = () => {
  if (!_appContainer) {
    // eslint-disable-next-line global-require
    _appContainer = require('./src/components/AppContainer').appContainer
  }
  return _appContainer
}

exports.onPreRouteUpdate = () => {
  const appContainer = getAppContainer()
  appContainer.closeMenu()
  appContainer.closeContactModal()
  appContainer.closeGartnerModal()
}
